// extracted by mini-css-extract-plugin
export default {"container":"InsideMenu_container__NTINr","placeHolderShimmer":"InsideMenu_placeHolderShimmer__1UYhd"};